import { createContext } from 'react';
import { MessageIssue } from '../../../../flowImportMessageValidationUtils';

/** Provides per-message issues to custom prop-field cell renderers for inline error display. */
export const PropIssuesContext = createContext<MessageIssue[]>([]);
